module.exports = __webpack_public_path__ + "img/VW.6b865b72.png";